// Mock-Daten für die Unternehmensberatungs-Website

export const faqData = [
  {
    id: 1,
    question: "Wie lange dauert die GmbH-Gründung?",
    answer: "Die Gründung einer GmbH dauert in der Regel 2-4 Wochen. Nach der notariellen Beurkundung wird die Gesellschaft ins Handelsregister eingetragen. Wir begleiten dich durch den gesamten Prozess und sorgen für einen reibungslosen Ablauf."
  },
  {
    id: 2,
    question: "Welches Stammkapital wird benötigt?",
    answer: "Für die Gründung einer GmbH ist ein Mindeststammkapital von 25.000 Euro erforderlich. Davon müssen mindestens 12.500 Euro bei Gründung eingezahlt werden. Bei einer UG (haftungsbeschränkt) ist die Gründung bereits ab 1 Euro möglich."
  },
  {
    id: 3,
    question: "Was kostet die GmbH-Gründung?",
    answer: "Die Kosten setzen sich zusammen aus Notarkosten (ca. 800-1.200 Euro), Handelsregistereintrag (ca. 150 Euro) und unseren Beratungsleistungen. Wir bieten transparente Komplettpakete ab 2.500 Euro an."
  },
  {
    id: 4,
    question: "Kann ich alleine eine GmbH gründen?",
    answer: "Ja, eine Ein-Personen-GmbH ist möglich. Du bist dann alleiniger Gesellschafter und kannst auch Geschäftsführer sein. Wir unterstützen dich bei allen notwendigen Schritten."
  },
  {
    id: 5,
    question: "Welche Unterlagen werden benötigt?",
    answer: "Für die Gründung benötigst du: Personalausweise aller Gesellschafter, Gesellschaftsvertrag, Nachweis über Stammkapital und ggf. Gewerbeanmeldung. Wir erstellen eine vollständige Checkliste für dich."
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Kostenlose Erstberatung",
    description: "Wir analysieren deine Situation und beraten dich zu den optimalen Gründungsoptionen.",
    icon: "MessageSquare"
  },
  {
    id: 2,
    title: "Vorbereitung & Dokumentation",
    description: "Erstellung aller notwendigen Dokumente und Verträge für deine GmbH-Gründung.",
    icon: "FileText"
  },
  {
    id: 3,
    title: "Notarielle Beurkundung",
    description: "Terminvereinbarung beim Notar und Begleitung bei der Beurkundung des Gesellschaftsvertrags.",
    icon: "PenTool"
  },
  {
    id: 4,
    title: "Handelsregistereintrag",
    description: "Anmeldung beim Handelsregister und Überwachung des Eintragungsprozesses.",
    icon: "BookOpen"
  },
  {
    id: 5,
    title: "Finale Schritte",
    description: "Gewerbeanmeldung, IHK-Anmeldung und alle weiteren behördlichen Formalitäten.",
    icon: "CheckCircle"
  }
];

export const marketplaceListings = [
  {
    id: 1,
    title: "Handelsgesellschaft mit Historie",
    industry: "Handel",
    foundedYear: 2015,
    stammkapital: 25000,
    price: 8500,
    location: "Berlin",
    status: "Verfügbar",
    description: "Handels-GmbH mit Unternehmensgeschichte seit 2015. Angaben laut Anbieter.",
    features: ["Bankverbindung (lt. Anbieter)", "Handelsregistereintrag", "IHK-Mitgliedschaft"]
  },
  {
    id: 2,
    title: "IT-Dienstleistungs GmbH",
    industry: "IT & Software",
    foundedYear: 2018,
    stammkapital: 25000,
    price: 12000,
    location: "München",
    status: "Verfügbar",
    description: "IT-GmbH mit bestehender Unternehmensstruktur und langjähriger Geschäftsbeziehung zu Banken (lt. Anbieter).",
    features: ["Bonitätsangabe lt. Anbieter", "Geschäftskonto (lt. Anbieter)", "Digitale Infrastruktur"]
  },
  {
    id: 3,
    title: "Beratungs-GmbH Frankfurt",
    industry: "Beratung",
    foundedYear: 2017,
    stammkapital: 25000,
    price: 9500,
    location: "Frankfurt",
    status: "Reserviert",
    description: "Beratungsgesellschaft mit bestehender Unternehmenshistorie und etablierten Strukturen (lt. Anbieter).",
    features: ["Langjährige Historie", "Angaben lt. Anbieter prüfen", "Handelsregistereintrag"]
  },
  {
    id: 4,
    title: "Import/Export GmbH",
    industry: "Handel",
    foundedYear: 2016,
    stammkapital: 25000,
    price: 11000,
    location: "Hamburg",
    status: "Verfügbar",
    description: "Internationale Handelsgesellschaft mit Erfahrung im Import/Export-Geschäft.",
    features: ["International ausgerichtet", "Zollnummer vorhanden", "EU-weit tätig"]
  },
  {
    id: 5,
    title: "Projektentwicklungs-GmbH",
    industry: "Immobilien",
    foundedYear: 2019,
    stammkapital: 50000,
    price: 15000,
    location: "Köln",
    status: "Verfügbar",
    description: "Projektentwicklungsgesellschaft mit erhöhtem Stammkapital und bestehender Unternehmenshistorie (lt. Anbieter).",
    features: ["Erhöhtes Stammkapital", "Geschäftskonto (lt. Anbieter)", "Bestehende Historie"]
  },
  {
    id: 6,
    title: "Vertriebs-GmbH NRW",
    industry: "Vertrieb",
    foundedYear: 2014,
    stammkapital: 25000,
    price: 9000,
    location: "Düsseldorf",
    status: "Verfügbar",
    description: "Vertriebs-GmbH mit langjähriger Unternehmensgeschichte (lt. Anbieter).",
    features: ["Lange Geschichte", "Bankbeziehungen (lt. Anbieter)", "Angaben prüfen"]
  },
  {
    id: 7,
    title: "Dienstleistungs-GmbH im Bereich Design/Werbung",
    industry: "Dienstleistung",
    foundedYear: 2000,
    stammkapital: 25000,
    price: 250000,
    location: "Ruhrgebiet",
    status: "Verfügbar",
    description:
      "Die Erbringung von Design- und Werbedienstleistungen, die Herstellung und der Vertrieb von Werbetechnik, digitalen Medien und Druckerzeugnissen aller Art.",
    features: [
      "Bankkonto (lt. Anbieter)",
      "Geschäftsführer bleibt zur Einarbeitung/Übergabe erhalten",
      "Unternehmensnachfolge",
      "Kaufpreis inkl. Inventar",
    ],
  },
  {
    id: 8,
    title: "Dienstleistungs-GmbH im Bereich Lizenzen/Rechte",
    industry: "Dienstleistung",
    foundedYear: 2004,
    stammkapital: 25000,
    price: 50000,
    location: "Ruhrgebiet",
    status: "Verfügbar",
    description:
      "Der Erwerb, die Verwaltung und die Gewährung von Lizenzen, Rechten, Marken- & Namensrechten.",
    features: [
      "Bankkonto (lt. Anbieter)",
      "Geschäftsführer bleibt zur Einarbeitung/Übergabe erhalten",
      "Bonitätsangabe lt. Anbieter",
    ],
  }
];

export const packageFeatures = [
  "Kostenlose Erstberatung",
  "Erstellung Gesellschaftsvertrag",
  "Geschäftsführervertrag",
  "Notar-Terminvereinbarung",
  "Handelsregister-Anmeldung",
  "Gewerbeanmeldung",
  "IHK-Anmeldung",
  "Finanzamt-Anmeldung",
  "Berufsgenossenschaft-Anmeldung",
  "Unterstützung bei Kontoeröffnung"
];

// Leistungsmerkmale (ersetzt frühere Testimonials)
export const serviceFeatures = [
  {
    id: 1,
    title: "Persönliche Begleitung",
    text: "Direkter Ansprechpartner während des Vermittlungsprozesses."
  },
  {
    id: 2,
    title: "Diskrete Vermittlung",
    text: "Unternehmensinformationen werden im Rahmen des Vermittlungsprozesses gezielt bereitgestellt."
  },
  {
    id: 3,
    title: "Strukturierter Ablauf",
    text: "Wir koordinieren die nächsten Schritte zwischen Interessenten, Anbietern und den beteiligten Stellen."
  }
];